import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    console.log('in Admin component');
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts